// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3519":"/chunks/WistiaEmbed","7585":"/chunks/ComponentHomePageBlogPosts","9363":"/chunks/ComponentHomePageWhySuperHosting"}[chunkId] || chunkId) + "." + {"1468":"ad06bc1557eedd343d39","3519":"be44b38a809cb614a4d9","7585":"89b51099d181a7542bb0","9363":"cbd26935416a05228085"}[chunkId] + ".js";
};